import { TableMap } from '../table-map';
import { findTable } from './find';

// Returns an array of cells in a row(s), where `rowIndex` could be a row index or an array of row indexes.
export var getCellsInRow = function getCellsInRow(rowIndex) {
  return function (selection) {
    var table = findTable(selection);
    if (!table) {
      return;
    }
    var map = TableMap.get(table.node);
    var indexes = Array.isArray(rowIndex) ? rowIndex : [rowIndex];
    return indexes.filter(function (index) {
      return index >= 0 && index <= map.height - 1;
    }).reduce(function (acc, index) {
      var cells = map.cellsInRect({
        left: 0,
        right: map.width,
        top: index,
        bottom: index + 1
      });
      return acc.concat(cells.map(function (nodePos) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var node = table.node.nodeAt(nodePos);
        var pos = nodePos + table.start;
        return {
          pos: pos,
          start: pos + 1,
          node: node,
          depth: table.depth + 2
        };
      }));
    }, []);
  };
};